import {api} from '../api/api'
import {apiYsz} from '../api/apiYsz'
import { apiNew } from '../api/apiNew'
/**
 * 获取公式是否被收藏
 */
export const getCollectInfoById = params => api('/ysz-content/phm-collect/isCollectByTypeId', params)

/**
 * 医学工具收藏/取消收藏
 */
export const drugToolCollect = params => api('/ysz-content/phm-collect/collect', params)

/**
 * 获取医生站公式是否被收藏
 */
export const getCollectInfoByIdYsz = params => apiYsz('drug/getCollectInfoById', params)

/**
 * 医生站公式收藏/取消收藏
 */
export const drugToolCollectYsz = params => apiYsz('content/drugToolCollect', params)


/** 微信分享上报 */
export const shareReport = params => api('/ysz-content/user/shareStatistics', params)

// 获取数据生产说明
export const getProduceExplain = params => api('/ysz-app/phmDataProduceExplain/getExplain', params, 'get')
/**
 * 医生站公式科室列表
 */
export const getDrugFormulaCategoryList = params => apiYsz('drug/getDrugFormulaCategoryList', params)
/**
 * 医生站科室下公式列表数据
 */
export const getDrugFormulaListByCategory = params => apiYsz('drug/getDrugFormulaListByCategory', params)





// WEBPACK FOOTER //
// ./src/server/home/index.js